import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('ownerToken'));
  const [loading, setLoading] = useState(true);
  const [qrCode, setQrCode] = useState(null);
  const [doorUrl, setDoorUrl] = useState(null);

  const bootstrap = useCallback(async () => {
    if (!token) { setLoading(false); return; }
    try {
      const res = await authAPI.me();
      setUser(res.data.data.user);
      setQrCode(res.data.data.qrCode);
      setDoorUrl(res.data.data.doorUrl);
    } catch {
      localStorage.removeItem('ownerToken');
      setToken(null);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { bootstrap(); }, [bootstrap]);

  const login = (data) => {
    const { token: t, user: u, qrCode: qr, doorUrl: du } = data;
    localStorage.setItem('ownerToken', t);
    setToken(t);
    setUser(u);
    setQrCode(qr);
    setDoorUrl(du);
  };

  const logout = () => {
    localStorage.removeItem('ownerToken');
    setToken(null);
    setUser(null);
    setQrCode(null);
    setDoorUrl(null);
  };

  const updateUser = (updates) => setUser(prev => ({ ...prev, ...updates }));

  return (
    <AuthContext.Provider value={{ user, token, loading, qrCode, doorUrl, login, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
